import React, { useEffect, useCallback } from 'react'
import { useState } from 'react';
import axios from 'axios';
import { Button, Form, Input } from 'reactstrap'
import SuccessPopups from '../../../../components/Popups/SuccessPopups';
import EmptyTable from '../../../../components/errorComponents/EmptyTable';
import { environment } from '../../../../env';
import Table from '../../../../components/Table'
import { useDispatch } from 'react-redux';
import AddPermissionType from '../../../../components/Modal/AddPermissionType';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import _ from "lodash";
import { getPermissionTypeAction, loaderAction } from '../../../../redux/actions/Index';
import { useSelector } from 'react-redux';
import { warningModalToggle } from './../../../../redux/actions/Index';
import WarningPopup from './../../../../components/Popups/WarningPopup';
import { MagnifyingGlass, Trash } from '@phosphor-icons/react';
import PathName from '../../../../components/PathName/PathName';


const PermissionType = () => {

  const dispatch = useDispatch()

  const user = useSelector((state) => state?.Reducers?.userdata);
  const permissionType = useSelector((state) => state?.ModalReducer?.permissiontype);
  const [filter, setFilter] = useState([])

  const onSubmit = (data) => {
    debounce(data);
  };
  const debounce = useCallback(
    _.debounce((_searchVal) => {
      Search(_searchVal);
    }, 500),
    []
  );
  const Search = (query) => {
    let arr = []
    permissionType.map((item, index) => {
      if (item.permission_type.toUpperCase().includes(query.toUpperCase())) {
        return arr.push(item)
      }
    })
    if (arr.length == 0) {
      setFilter([])
      toast.error('Permission Type not found !', {
        position: toast.POSITION.TOP_CENTER
      });
    } else {
      return setFilter(arr)
    }
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const getPermissionType = () => {
    try {
      axios.get(`${environment.baseUrl}permission-type/`).then(res => {
        dispatch(getPermissionTypeAction(res.data));
      }).catch(res => {
        console.log("error");
      })
    }
    catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {

  }, [permissionType])

  const columns = [
    {
      name: 'Permission Type',
      selector: row => row.permission_type,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      style: {
        fontSize: "2.3rem",
      }
    }, {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Action',
      cell: (row) => <div className="d-flex justify-content-center align-items-center gap-2 ">
        {user?.role != 'superadmin' ? <>
          <AddPermissionType permissionType={permissionType} button='edit' title='Edit Permission Type' data={row} />
        </> : <>
          <AddPermissionType permissionType={permissionType} button='edit' title='Edit Permission Type' data={row} />
          <button onClick={() => delite(row.id)} id={row.ID} className="icon-bg-red border-0 px-2 py-3 rounded"><Trash size="28" className='icon-color-red' /></button>
        </>}
      </div>,
    }
  ];
  const column = [
    {
      name: 'Permission Type',
      selector: row => row.permission_type,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      style: {
        fontSize: "2.3rem",
      }
    }, {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: '',
      style: {
        fontSize: "2.3rem",
      }
    }
  ];

  const delite = (id) => {
    dispatch(warningModalToggle(id));
  };
  const deleteData = (id) => {
    dispatch(loaderAction(true))
    dispatch(warningModalToggle(id))
    axios.delete(`${environment.baseUrl}put-permission-type/${id}`).then(res => {
      if (res.data.code === 200) {
        getPermissionType()
        dispatch(loaderAction(false))
      }
    })
      .catch(res => {
        dispatch(loaderAction(false))
        console.log("error");
      })
  };

  return (
    <>
      <PathName />
      <SuccessPopups />
      <WarningPopup deleteData={deleteData} />
      <div className="villages-main">
        <Form onSubmit={handleSubmit(Search)}>
          <div className='my-3 pb-1'>
            <div className='d-flex align-items-center bg-white px-4 border-radius-10'>
              <MagnifyingGlass size={30} />
              <Input
                className='p-4 border-0 shadow-none   w-100 fs-3 title-font-500 fs-2 '
                type='text'
                onChange={(e) => { onSubmit(e.target.value) }}
                autoComplete='off'
                placeholder='Search Permission Type Here...'
              />
            </div>
            <br />
          </div>
        </Form>
        <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
          <div >
            <div className='d-flex justify-content-between align-items-center'>
              <h1 className='title-font-bold '>Permission Type</h1>
              <AddPermissionType title='Create Permission Type' permissionType={permissionType} />
            </div>
            {filter?.length == 0 ?
              <>
                {permissionType?.[0] == undefined ? <EmptyTable /> : <Table columns={user?.role == "user" ? column : columns} data={permissionType} />}
              </> :
              <>
                <Table columns={user?.role == "user" ? column : columns} data={filter} />
              </>}
          </div>
        </div>
        <div className="d-flex gap-5">
        </div>
      </div>
    </>
  )
}

export default PermissionType
